// src/app/interceptors/csrf.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiRequest = req.url.startsWith(this.apiBaseUrl);
    const isCsrfEndpoint = req.url.endsWith('/sanctum/csrf-cookie');
    const token = this.cookieService.get('XSRF-TOKEN');

    // No intervención si ya hay token, no es API, o es la propia petición csrf-cookie
    if (token || !isApiRequest || isCsrfEndpoint) {
      return next.handle(this.addCsrfHeaders(req, token));
    }

    // Obtener csrf-cookie antes de continuar
    return this.http.get(`${this.apiBaseUrl}/sanctum/csrf-cookie`, { withCredentials: true }).pipe(
      switchMap(() => {
        const newToken = this.cookieService.get('XSRF-TOKEN');
        return next.handle(this.addCsrfHeaders(req, newToken));
      }),
      catchError(err => {
        console.error('[CSRF Interceptor] Error al obtener csrf-cookie', err);
        return throwError(() => err);
      })
    );
  }

  private addCsrfHeaders(req: HttpRequest<any>, token: string): HttpRequest<any> {
    if (!token) {
      return req.clone({ withCredentials: true });
    }

    return req.clone({
      withCredentials: true,
      setHeaders: {
        'X-XSRF-TOKEN': decodeURIComponent(token),
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  }
}
